export const formatRelative = (dateString) => {
  if (!dateString) return "Never";
  const diff = Date.now() - new Date(dateString).getTime();
  if (Number.isNaN(diff) || diff < 0) return "just now";
  const minute = 60 * 1000;
  const hour = 60 * minute;
  const day = 24 * hour;
  const month = 30 * day;
  const year = 365 * day;
  const phrase = (value, unit) => `${value} ${unit}${value === 1 ? "" : "s"} ago`;
  if (diff < minute) return "just now";
  if (diff < hour) return phrase(Math.floor(diff / minute), "minute");
  if (diff < day) return phrase(Math.floor(diff / hour), "hour");
  if (diff < month) return phrase(Math.floor(diff / day), "day");
  if (diff < year) return phrase(Math.floor(diff / month), "month");
  return phrase(Math.floor(diff / year), "year");
};

export const roleLabel = (role) => (role ? role.charAt(0).toUpperCase() + role.slice(1) : "");

export const roleBadgeClass = (role) => {
  if (role === "owner") {
    return "border-purple-400/40 bg-purple-500/20 text-purple-800 dark:text-purple-200";
  }
  if (role === "admin") {
    return "border-blue-400/40 bg-blue-500/20 text-blue-800 dark:text-blue-200";
  }
  if (role === "helper") {
    return "border-teal-400/40 bg-teal-500/20 text-teal-800 dark:text-teal-200";
  }
  return "border-amber-400/40 bg-amber-400/20 text-amber-800 dark:text-amber-200";
};

export const statusBadgeClass = (isActive) =>
  isActive
    ? "border-green-500/20 bg-green-500/10 text-green-700 dark:text-green-300"
    : "border-gray-300 bg-gray-100 text-gray-600 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-300";

// Shared chip shell so the users list and the profile page render identical badges.
export const badgeClass =
  "inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-xs font-medium";
